export default {
  namespaced: true,
  state: {
    vendorFilter: "",
    productNameFilter: "",
    filterableVendors: [],
  },
  getters: {
    vendorFilter: state => state.vendorFilter,
    getProductNameFilter: state => state.productNameFilter,
    getFilterableVendors: state => state.filterableVendors,
  },
  actions: {
    setProductNameFilter: ({ commit }, filter) => {
      commit("setProductNameFilter", filter);
    },
    setVendorFilter: ({ commit }, filter) => {
      commit("setVendorFilter", filter);
    },
    setFilterableVendors: ({ commit }, vendors) => {
      commit("setFilterableVendors", vendors);
    },
  },
  mutations: {
    setProductNameFilter: (state, filter) => {
      state.productNameFilter = filter.toLowerCase();
    },
    setVendorFilter: (state, filter) => {
      state.vendorFilter = filter;
    },
    setFilterableVendors: (state, vendors) => {
      state.filterableVendors = [...new Set([...state.filterableVendors, ...vendors])];
    },
  },
};
